import { h, $ } from './dom';
import { bus } from '../core/bus';

/** Stacked toasts: each one has its own timer, so a new toast never hides early. */
export function initToasts(): void {
  bus.on('toast', show);
}

const MAX = 2;

export function show(text: string): void {
  const host = $('toasts');
  const el = h('div', { class: 'toast' }, text);
  host.appendChild(el);
  while (host.children.length > MAX) host.firstElementChild?.remove();
  const life = Math.min(5000, 1800 + text.length * 45);
  window.setTimeout(() => {
    el.classList.add('out');
    window.setTimeout(() => el.remove(), 300);
  }, life);
}
